import { render, staticRenderFns } from "./GroupExhibition.vue?vue&type=template&id=450962ac&"
import script from "./GroupExhibition.vue?vue&type=script&lang=js&"
export * from "./GroupExhibition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports